import clsx from 'clsx';
import Avatar from '@/components/Avatar';

export interface RosterSidebarGroup {
  id: string;
  name: string;
  orgId: string;
  orgName: string;
  imageUrl?: string | null;
}

interface Props {
  group: RosterSidebarGroup;
  selected: boolean;
  onSelect: (group: RosterSidebarGroup) => void;
}

/** Group row in the roster sidebar tree (PrayerGroupListItem pattern). */
export default function RosterGroupListItem({ group, selected, onSelect }: Props) {
  return (
    <button
      onClick={() => onSelect(group)}
      className={clsx(
        'flex w-full items-center gap-3 rounded-lg py-2 pl-6 pr-3 text-left transition',
        selected ? 'bg-flock-navy-100' : 'hover:bg-flock-navy-50'
      )}
    >
      <Avatar
        src={group.imageUrl}
        name={group.name}
        sizeClass="h-9 w-9"
        textClass="text-xs"
        bgClass="bg-flock-navy-500"
      />
      <span className="min-w-0 flex-1 truncate text-sm font-medium text-flock-navy-800">
        {group.name}
      </span>
    </button>
  );
}
